import type { TripStatus } from '@raahi/shared';
import { formatPkr } from '@raahi/shared';
import type { DriverTripDto } from '../api/driver.js';

interface Props {
  trip: DriverTripDto;
  onArrived: () => void;
  onStart: () => void;
  onComplete: () => void;
  busy?: boolean;
}

const STAGE_LABEL: Record<TripStatus, string> = {
  requested: 'Awaiting match',
  searching: 'Awaiting match',
  assigned: 'Head to pickup',
  arriving: 'Head to pickup',
  arrived: 'Wait for rider',
  in_progress: 'On trip',
  completed: 'Trip completed',
  cancelled: 'Trip cancelled',
};

export function StageControls({ trip, onArrived, onStart, onComplete, busy }: Props) {
  const status = trip.status;
  const targetLabel = status === 'in_progress' ? trip.drop.label : trip.pickup.label;

  return (
    <div className="card p-4">
      <div className="flex items-center justify-between">
        <span className="chip border-go/40 bg-go/10 text-go">{STAGE_LABEL[status]}</span>
        <span className="num text-sm font-semibold">{formatPkr(trip.fare.total)}</span>
      </div>

      <div className="mt-3">
        <p className="text-xs uppercase tracking-wide text-muted">
          {status === 'in_progress' ? 'Drop-off' : 'Pickup'}
        </p>
        <p className="font-display text-lg font-semibold">{targetLabel}</p>
      </div>

      <div className="mt-4 grid gap-2">
        {(status === 'assigned' || status === 'arriving') && (
          <button type="button" className="btn-stage" onClick={onArrived} disabled={busy}>
            I have arrived
          </button>
        )}
        {status === 'arrived' && (
          <button type="button" className="btn-go" onClick={onStart} disabled={busy}>
            Start trip
          </button>
        )}
        {status === 'in_progress' && (
          <button type="button" className="btn-go" onClick={onComplete} disabled={busy}>
            Complete trip
          </button>
        )}
      </div>
    </div>
  );
}
